/* eslint-disable no-unreachable */
import React from 'react';
import Latest from './Latest';
import Producers from './Producers';
import { Layout, Spin, Button, notification } from 'antd';
import TVLoginModal from './TVLoginModal';
import IdentityModal from './IdentityModal';
// import Player5 from './Player6';
import { logoutApi, getGeneralInfoApi, getCountriesApi, getLanguageMoviesApi, getPopularMoviesApi, timeout,
  getUpcomingMoviesApi, getLatestMoviesApi, getUserMoviesApi, getSharedURLMovieApi, isSafariBrowser,
  writeEventToDb, writeUserEventToDb } from './utils/ApiUtils';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';
import firebase from './utils/firebase';
import { COLORS } from './utils/Constants';
import MenuWeb from './common/MenuWeb';
import MenuPopup from './common/MenuPopup';
import MenuMobile from './common/MenuMobile';
import TestStream from './TestStream';

let isMobile = false, email = '', idStatus = "", identityVerificationTime = 0;
const { Content } = Layout;
const latest = 'LATEST', popular = 'POPULAR', upcoming = 'UPCOMING', myMovies = 'MY MOVIES', producers = 'PRODUCERS';
let emptyContent = '', status = true, oldFirebaseRef = '', refreshTimeStamp = '', 
  currentItemValue = '', currentItemMore = false, isFirebaseAuthDone = false, userObject = '', userId = 0, movieId = 0;
let myMoviesEmpty = 'You do not have any active purchases.';
const whyButton = <a target='_blank' style={{ color: COLORS.red }} rel='noopener noreferrer' href='https://docs.hit.movie/faqs#playing-restrictions'>Why does this happen?</a>;
const tvAppbtn = <a target='_blank' style={{ color: COLORS.red }} rel='noopener noreferrer' href='https://docs.hit.movie/apps'>Download the TV Apps now</a>;
const otherUser = "Someone else seems to have logged in to your account. Only one user can watch a movie at a time.";
const movieExpired = "Your movie has expired. Please buy the movie again to watch.";
const contentString = 'No content available.';
const noUpcoming = 'No upcoming movie available in your region.';

const openNotification = (title, message, showButton) => {
  if(status) {
    status = false;
    const btn = showButton===1 ? whyButton : tvAppbtn;
    if(showButton) {
      notification.open({
        message: title,
        duration: 10,
        description: message,
        btn,
        onClose: () => {
          status = true;
        }
      });
    } else {
      notification.open({
        message: title,
        duration: 10,
        description: message,
        onClose: () => {
          status = true;
        }
      });
    }
  }
};

export default class AppLoggedIn extends React.Component {
  constructor(props) {
    super(props);
    isMobile = this.props.isMobile;
    this.state = {
      index: 0, collapsed: isMobile, loggedIn: false, playIt: false, loader: true, tvModalVisible: false, identityPopupVisible: false,
      sessionValue: '', player: false, sticky: false, width: window.innerWidth, height: window.innerHeight, visible: false,
      countriesData: '', generalInfoData: '', movies: [], tabLanguages: [], playerObjects: null, moreLanguage: '', 
      selectedKey: latest, idStatusFlag: 0, isTesting: false, isProducer: false,
    };
  }
  componentDidMount() {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue+' url params='+JSON.stringify(this.props));
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
    this.loadData();
    // if(isMobile) {
    //   notification.config({ placement: 'bottomRight' });
    //   if(navigator.userAgent&&navigator.userAgent.includes('iPhone')) {
    //     openNotification("Recommendation", "Hit.Movie may not work in iPhone browsers. Hit.Movie is designed for a large-screen experience at 4K cinematic quality. You can buy movies here and watch them on your TV.", 2);
    //   } else {
    //     openNotification("Recommendation", "Hit.Movie is designed for a large-screen experience at 4K cinematic quality. You can buy movies here and watch them on your TV.", 2);
    //   }
    // } else if(isSafariBrowser()) {
    //   openNotification("Recommendation", "For best experience please use Chrome or Firefox browser.", 0); 
    // }
    window.addEventListener('resize', this.updateDimensions);
    this.pageLoadEvent();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
  updateDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };
  pageLoadEvent = async() => {
    console.log('fetch basic info');
    let basicInfo = this.props.basicInfo;
    let uniqueId = this.props.uniqueId;
    let analyticsObj = { ...basicInfo, eventName: 'homePageLoaded', timeStamp: Date.now() };
    let updates = { };
    updates[uniqueId] = analyticsObj;
    console.log('basic Info='+JSON.stringify(updates));
    writeEventToDb(updates);
  }
  onDatabaseEvents = (event) => {
    if(event) {
      let basicInfo = this.props.basicInfo;
      console.log('Player Module on Database Events'+JSON.stringify(event)+' basicInfo='+JSON.stringify(basicInfo));
      let analyticsObj = { movieId: movieId, userObject: userObject, timeStamp: Date.now(), ...event, ...basicInfo };
      writeUserEventToDb(userId, analyticsObj);
    }
  } 
  loadData = () => {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue);
    let windowUrl = window.location.href;
    if(sessionValue) {
      if(windowUrl.includes('testingStream')) {
        this.setState({ isTesting: true });
      }
      if(windowUrl.includes('upcoming')) {
        this.setState({ selectedKey: upcoming });
        this.getSetUpcomingMovies(sessionValue);
      } else if(windowUrl.includes('mymovies')) {
        this.setState({ selectedKey: myMovies });
        this.getMyMovies(sessionValue);
      } else if(windowUrl.includes('addmovie')||windowUrl.includes('managemovie')||windowUrl.includes('identities')) {
        this.setState({ selectedKey: producers });
      } else if(windowUrl.includes('/movie/')) {
        this.setState({ selectedKey: 'movie1' });
        this.getSharedUrl(sessionValue, windowUrl);
      } else {
        currentItemValue = latest;   
        this.getSetLatestMovies(sessionValue);
      }
    }
    getGeneralInfoApi(sessionValue)
    .then(response => {
      console.log('get GeneralInfo Api data='+(response));
      if(windowUrl.includes('addmovie')) {
        this.setState({ loader: false });
      }
      if(response.ok) {
        this.setState({ generalInfoData: response.info, tabLanguages: response.info.languages });
        userObject = response.info.user;
        userId = userObject.id;
        idStatus = userObject.identityVerification;
        identityVerificationTime = userObject.identityVerificationTime ? userObject.identityVerificationTime : Date.now()/1000;
        email = userObject.emailAddress;
        this.setState({ userId: userId, isProducer: userObject.isProducer });
        if(!userObject.isProducer) {
          if(windowUrl.includes('addmovie')||windowUrl.includes('managemovie')||windowUrl.includes('identities')) {
            emptyContent = 'No content available.';
            this.setState({ loader: false });
          }
        }
        localStorage.setItem('userObj', JSON.stringify(userObject));
        if(!isFirebaseAuthDone) {
          let firebaseToken = localStorage.getItem('firebaseToken') || ''; 
          if(firebaseToken) {
            isFirebaseAuthDone = true;
            firebase.auth().signInWithCustomToken(firebaseToken);
            this.firebaseRefreshTimeStampListen();
            this.listenIdStatus();
          }
        }
      } else {
        console.log('General Info fetchig failed!');
      }
    })
    .catch((error) => {
      console.log('Error loading data='+JSON.stringify(error));
    });
    getCountriesApi(sessionValue)
    .then(response => {
      console.log('get supported CountriesApi data='+JSON.stringify(response));
      if(response.ok) {
        this.setState({ countriesData: response.info });
      } else {
        console.log('country fetching failed');
      }
    })
    .catch((error) => {
      console.log('Error loading data='+JSON.stringify(error));
    });
  }
  getSetLatestMovies = (sessionValue) => {
    getLatestMoviesApi(sessionValue)
    .then(response => {
      console.log('getLatestMoviesApi data='+JSON.stringify(response));
      emptyContent = contentString;
      if(response.ok) {
        this.setState({ movies: response.info, loader: false });
      } else {
        console.log('getLatestMoviesApi fetching failed');
        this.setState({ movies: [], loader: false });
      }
    })
    .catch((error) => {
      console.log('Error loading data='+JSON.stringify(error));
      emptyContent = contentString;
      this.setState({ movies: [], loader: false });
    });
  }
  getSetUpcomingMovies = (sessionValue) => {
    getUpcomingMoviesApi(sessionValue)
    .then(response => {
      console.log('getUpcomingMoviesApi data='+JSON.stringify(response));
      emptyContent = noUpcoming;
      if(response.ok) {
        this.setState({ movies: response.info, loader: false });
      } else {
        console.log('getUpcomingMoviesApi fetching failed');
        this.setState({ movies: [], loader: false });
      }
    })
    .catch((error) => {
      console.log('Error loading data='+JSON.stringify(error));
      emptyContent = noUpcoming;
      this.setState({ movies: [], loader: false });
    });
  }
  getMyMovies = (sessionValue) => {
    getUserMoviesApi(sessionValue)
    .then(response => {
      console.log('getUserMoviesApi data='+JSON.stringify(response));
      if(response.ok) {
        let responseObj = response.info;
        let moviesObj = responseObj.myMovies;
        let tempArray = [];
        if(moviesObj&&moviesObj.length>0) {
          moviesObj.map((item, index) => {
            tempArray.push({ upload: item.movieUpload, userpurchaseStatus: true, userCurrentCountry: responseObj.userCurrentCountry, 
              expiryTime: item.expiryTime, purchaseTime: item.purchaseTime });
          });
          console.log('mymoviesObj='+JSON.stringify(tempArray));
          this.setState({ movies: tempArray, loader: false });
        } else {
          this.setState({ movies: [], loader: false });
        }
      } else {
        console.log('getUserMoviesApi fetching failed');
        this.setState({ movies: [], loader: false });
      }
    })
    .catch((error) => {
      console.log('Error getUserMoviesApi data='+JSON.stringify(error));
      this.setState({ movies: [], loader: false });
    });
  }
  setUrlToMyMovies = (sessionValue) => {
    this.setState({ selectedKey: myMovies, loader: true });
    this.getMyMovies(sessionValue);
  }
  getSharedUrl = (sessionValue, windowUrl) => {
    getSharedURLMovieApi(sessionValue, windowUrl)
    .then(response => {
      if(response.ok) {
        let tempObj = [response.info];
        console.log('getSharedURLMovieApi data='+JSON.stringify(tempObj));
        this.setState({ movies: tempObj, loader: false });
      } else {
        console.log('getSharedURLMovieApi fetching failed');
        this.setState({ movies: [], loader: false });
      }
    })
    .catch((error) => {
      console.log('Error getSharedURLMovieApi data='+JSON.stringify(error));
      this.setState({ movies: [], loader: false });
    });
  }
  getSetPopularMovies = (sessionValue) => {
    getPopularMoviesApi(sessionValue)
    .then(response => {
      console.log('getPopularMoviesApi data='+JSON.stringify(response));
      if(response.ok) {
        this.setState({ movies: response.info });
      } else {
        console.log('getPopularMoviesApi fetching failed');
      }
    })
    .catch((error) => {
      console.log('Error loading data='+JSON.stringify(error));
    });
  }
  getSetLanguageMovies = (sessionValue, language) => {
    getLanguageMoviesApi(sessionValue, language)
    .then(response => {
      console.log('getLanguageMoviesApi data='+JSON.stringify(response));
      emptyContent = contentString;
      if(response.ok) {
        this.setState({ movies: response.info, loader: false });
      } else {
        console.log('getLanguageMoviesApi fetching failed');
        this.setState({ movies: [], loader: false });
      }
    })
    .catch((error) => {
      console.log('Error loading data='+JSON.stringify(error));
      emptyContent = contentString;
      this.setState({ movies: [], loader: false });
    });
  }
  loadProducer = (val) => {
    if(isMobile) {
      emptyContent = 'To list your movie please login with a laptop/desktop.';
      this.setState({ movies: [], index: 0, moreLanguage:'', selectedKey: val, collapsed: true });  
    } else {
      this.setState({ selectedKey: val });
    }
  }
  loadMenu = (value, more, noLoading) => {
    currentItemValue = value;
    currentItemMore = more;
    let sessionValue = this.state.sessionValue;
    console.log('loading Menu sessionValue='+sessionValue);
    emptyContent = '';
    if(noLoading) {
      this.setState({ index: 0, moreLanguage:'', selectedKey: value, collapsed: true });
    } else {
      this.setState({ index: 0, loader: true, moreLanguage:'', selectedKey: value, collapsed: true });
    }
    switch(value) {
      case latest:
        this.getSetLatestMovies(sessionValue); 
        break;
      case upcoming:
        this.getSetUpcomingMovies(sessionValue); 
        break;
      case myMovies:
        this.getMyMovies(sessionValue);
        break;
      case popular:
        this.getSetPopularMovies(sessionValue); 
        break;
      case producers:
        this.setState({ index: 1, loader: false });
        break;
      default:
        this.hide();
        if(more) {
          this.setState({ moreLanguage: value });
        }
        this.getSetLanguageMovies(sessionValue, value); 
        break;
    }
    document.documentElement.scrollTop = 0;
  }
  openIdentityPopup = () => {
    console.log('opening identity popup');
    this.setState({ identityPopupVisible: true });
  }
  closeIdentityPopup = () => {
    console.log('closing identity popup');
    this.setState({ identityPopupVisible: false });
  }
  listenIdStatus = () => {
    console.log('listening identity status from firebase. userId='+userId);
    try {
      firebase.database().ref("users").child(userId).child("Identity Verification").on("value", snapshot => {
        let firebaseVal = snapshot.val();
        console.log('identity status firebase. idStatus='+idStatus+' firebase val='+firebaseVal);
        if(firebaseVal&&firebaseVal!=idStatus) {
          idStatus = firebaseVal;
          console.log('identity status changed. idStatus='+idStatus);
          let oldidStatusFlag = this.state.idStatusFlag;
          this.setState({ idStatusFlag: oldidStatusFlag+1 });
        }
      }); 
    } catch(e) {
      console.log('firebase error='+e);
    }
  }
  onClose = () => {
    this.setState({ player: false, playerObjects: null });
    if(oldFirebaseRef) {
      oldFirebaseRef.off();
    }
  }
  openPlayer = async(playerObjects) => {
    console.log('opening player2');
    if(playerObjects) {
      movieId = playerObjects.uploadId;
      this.setState({ player: true, playerObjects: playerObjects });
      let currentLocator = '';
      if(playerObjects.isTrailer) {
        currentLocator = '';
      } else if(playerObjects.movieObj.azureStreamingLocatorName) {
        currentLocator = playerObjects.movieObj.azureStreamingLocatorName;
      }
      if(oldFirebaseRef) {
        oldFirebaseRef.off();
      }
      if(currentLocator) {
        this.firebaseMovieListen(currentLocator);
      }
    }
  }
  firebaseMovieListen = (currentLocator) => {
    let currentCountry = userObject.location.country;
    oldFirebaseRef = firebase.database().ref("users").child(userId).child(currentLocator).child(currentCountry);
    oldFirebaseRef.on("child_changed", snapshot => {
      let snapValue = snapshot.val();
      let snapKey = snapshot.key;
      let expired = 0;
      console.log('movie listener userId='+userId+' currentLocator='+currentLocator+' currentCountry='+currentCountry+' snapKey='+snapKey+' snapValue='+snapValue);
      if(snapKey) {
        if(snapKey=="token") {
          let sessionValue = this.state.sessionValue;
          if(sessionValue!==snapValue) {
            expired = 1;
          }
        } else if(snapKey=="expiryStatus"&&snapValue) {
          expired = 2;
        }
      }
      if(expired) {
        setTimeout(() => {
          this.setState({ player: false, playerObjects: null }); 
          openNotification(': (', expired==2 ? movieExpired : otherUser, 1);
          if(oldFirebaseRef) {
            oldFirebaseRef.off();
          }
        }, 5000);
      }
    });
  }
  firebaseRefreshTimeStampListen = async() => {
    try {
      await timeout(500);
      while(userId<1) {
        await timeout(500);
      }
      console.log('user id='+userId);
      firebase.database().ref("users").child(userId).child("refreshTimeStamp").on("value", snapshot => {
        console.log('refreshTimeStamp changed.');
        let timeStampVal = snapshot.val();
        console.log('firebase User Listen timeStampVal='+timeStampVal+' refreshTimeStamp='+refreshTimeStamp);
        if(refreshTimeStamp&&(refreshTimeStamp!=timeStampVal)) {
          console.log('need to refresh '+refreshTimeStamp+' timeStampVal='+timeStampVal+' currentItemValue='+currentItemValue+' '+currentItemMore);
          refreshTimeStamp = timeStampVal;
          if(currentItemValue) {
            this.loadMenu(currentItemValue, currentItemMore, true);
          }
        } else {
          refreshTimeStamp = timeStampVal;
        }
      }); 
    } catch(e) {
      console.log('firebase error='+e);
    }
  }
  logout = () => {
    localStorage.clear();
    this.props.goToLanding(2);
    window.history.replaceState(null, null, "/");
    window.scroll({ top: 0, left: 0 });
    this.setState({ sessionValue: '', tabLanguages: [], movies: [] });
    let email = 'deepak@peopledock.com';
    logoutApi(email)
    .then(response => {
      console.log('got login='+(response));
      if(response.ok) {
        console.log('Logout Success');
      } else {
        console.log('Logout Failed');
      }
    })
    .catch((error) => {
      console.log('Error getting logout'+JSON.stringify(error));
    });
  }
  switchCollapse = (collapsed) => {
    this.setState({ collapsed: !collapsed });
  }
  setModalVisible = () => {
    this.setState({ tvModalVisible: false });
  }
  hide = () => {
    this.setState({
      visible: false,
    });
  };
  showLoader = (value) => {
    this.setState({ loader: value });
  }
  handleVisibleChange = visible => {
    this.setState({ visible });
  };
  shouldComponentUpdate(nextProps, nextState) {
    let playerStatus = this.state.player;
    if(playerStatus!==nextState.player) {
      return true;
    }
    let oldStreamObj = this.state.playerObjects;
    if(oldStreamObj!==nextState.playerObjects) {
      return true;
    }
    let falseState = (playerStatus||(nextState&&(this.state.height!==nextState.height||this.state.width!==nextState.width)));
    if(falseState) {
      return false;
    }
    return true;  
  }
  render() {
    let tabLanguages = this.state.tabLanguages;
    let languagesTop = [];
    let pathArray = ['/', '/latest', '/upcoming', '/mymovies' ];
    tabLanguages.map((item, index) => {
      pathArray.push('/'+item);
    });
    if(tabLanguages.length>3) {
      languagesTop = tabLanguages.slice(0, 5);
      tabLanguages = tabLanguages.slice(5, tabLanguages.length);
    }
    let collapsed = this.state.collapsed;
    let moreLanguage = this.state.moreLanguage;
    let sessionVal = this.state.sessionValue;
    let loaderState = this.state.loader;
    if(this.state.isTesting) {
      return (
        <TestStream />
      );
    }
    let isVerified = idStatus=="Passed";
    let showContent = loaderState ? '' : (this.state.selectedKey===myMovies ? myMoviesEmpty : emptyContent);
    console.log('sessionVal='+sessionVal+' array1='+JSON.stringify(pathArray));
    let content = <MenuPopup tabLanguages={tabLanguages} loadMenu={this.loadMenu} />;
    return (
      <Router>
      <Layout className="site-layout">
        { isMobile
        ?
        <MenuMobile email={email} languagesTop={languagesTop} content={content} moreLanguage={moreLanguage} 
        sessionValue={sessionVal} collapsed={collapsed} selectedKey={this.state.selectedKey} 
        visible={this.state.visible} handleVisibleChange={this.handleVisibleChange} loadMenu={this.loadMenu} 
        loadProducer={this.loadProducer} logout={this.logout} isProducer={this.state.isProducer}
        switchCollapse={this.switchCollapse} setModalVisible={this.setModalVisible} />
        :
        <MenuWeb email={email} languagesTop={languagesTop} content={content} moreLanguage={moreLanguage} 
        openIdentityPopup={this.openIdentityPopup} selectedKey={this.state.selectedKey} visible={this.state.visible} 
        handleVisibleChange={this.handleVisibleChange} loadMenu={this.loadMenu} loadProducer={this.loadProducer} 
        logout={this.logout} isProducer={this.state.isProducer} isVerified={isVerified} idStatus={idStatus} />
        }
      <Layout>
      <Content style={{ marginLeft: isMobile ? 0 : 200, backgroundColor: COLORS.darkBlue, paddingTop: 40 }}>
        { this.state.loader &&
          <div style={{ position: 'fixed', backgroundColor: 'rgba(10, 26, 42, 0.6)', top: 0, bottom: 0, left: 0, right: 0, zIndex: 9999 }}>
            <Spin size='large' style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
          </div>
        }
        <div onClick={() => { if(isMobile) this.setState({ collapsed: true }) }} className="site-layout-background" 
        style={{ backgroundColor: COLORS.darkBlue, minHeight: window.innerHeight-40 }}>
          { this.state.isProducer
          ?
          <Switch> 
            <Route exact path={['/addmovie', '/managemovie', '/paymentstatus', '/identities']}>
              <Producers generalInfoData={this.state.generalInfoData} tabLanguages={this.state.tabLanguages} 
              countriesData={this.state.countriesData} userObject={userObject} showLoader={(val)=>{this.showLoader(val)}} />
            </Route> 
            <Route path={pathArray} >
              <Latest sessionValue={sessionVal} movies={this.state.movies} openPlayer={this.openPlayer} 
              basicInfo={this.props.basicInfo} userObject={userObject} userId={this.state.userId} isVerified={isVerified}
              content={showContent} showLoader={(val)=>{this.showLoader(val)}} setUrlToMyMovies={this.setUrlToMyMovies}
              openIdentityPopup={this.openIdentityPopup} />
            </Route> 
          </Switch> 
          :
          <Switch> 
            <Route path={pathArray} >
              <Latest sessionValue={sessionVal} movies={this.state.movies} openPlayer={this.openPlayer} 
              basicInfo={this.props.basicInfo} userObject={userObject} userId={this.state.userId} isVerified={isVerified}
              content={showContent} showLoader={(val)=>{this.showLoader(val)}} setUrlToMyMovies={this.setUrlToMyMovies}
              openIdentityPopup={this.openIdentityPopup} />
            </Route> 
          </Switch> 
          }
        </div>
        {/* { this.state.player &&
          <Player5 playerObjects={this.state.playerObjects} setVisibility={this.onClose} basicInfo={this.props.basicInfo}
          userObject={userObject} onDatabaseEvents={(event) => { this.onDatabaseEvents(event) }} />
        } */}
        { this.state.tvModalVisible && 
          <TVLoginModal modalNumber={4} sessionValue={sessionVal} email={email} setVisibility={this.setModalVisible} />
        }
        { this.state.identityPopupVisible && 
          <IdentityModal statusValue={idStatus} identityVerificationTime={identityVerificationTime} sessionValue={sessionVal} 
          closeIdentityPopup={this.closeIdentityPopup} />
        }
      </Content>
      </Layout>
    </Layout>
    </Router> 
    );
  }
}
